<template>
    <div v-if="leaderBoardPlayers.length" class="LeaderBoard">
        <div class="header-wrapper">
            <img src="@/assets/images/theory_image.png" />
            <div class="headers">
                <h4>
                    {{ course.lifeskillNumber }} -
                    {{ $t(`dashboard.general.lifeskillLabels.${course.lifeskillNumber}`) }}
                </h4>
                <h3>{{ journey.name }}</h3>
            </div>
        </div>

        <ul class="leader-board">
            <li v-for="(player, i) of leaderBoardPlayers" :key="player.lastName" class="leader-board-player">
                <div class="left-side">
                    <img v-if="i === 0" src="@/assets/images/golden-rank-icn.png" alt="golden rank icon" />
                    <img v-else-if="i === 1" src="@/assets/images/silver-rank-icn.png" alt="silver rank icon" />
                    <img v-else-if="i === 2" src="@/assets/images/bronze-rank-icn.png" alt="bronze rank icon" />
                    <p>{{ player.firstName }} {{ player.lastName || '' }}</p>
                </div>
                <div class="right-side">
                    {{ player.score + ' Points' }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        gameId: {
            type: String,
            required: true
        },

        teamGoal: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            leaderBoardPlayers: []
        };
    },

    computed: {
        ...mapGetters({
            getJourneyById: 'moduleCourse/getJourneyById',
            getStepById: 'moduleCourse/getStepById'
        }),

        course() {
            return this.$store.state.moduleCourse.courses[this.journey?.courseId];
        },

        journey() {
            return this.getJourneyById(this.teamGoal.journeyId);
        }
    },

    async mounted() {
        await this.getLeaderBoard();
    },

    beforeDestroy() {
        clearInterval(this.intervalId);
    },

    methods: {
        async getLeaderBoard() {
            this.leaderBoardPlayers = await this.$store.dispatch('moduleMemoransier/getLeaderboard', this.gameId);
        }
    }
};
</script>

<style lang="scss" scoped>
.LeaderBoard {
    color: white;
    background: #18194c;
    box-shadow: 0px 2px 23px rgba(79, 79, 79, 0.1);
    border-radius: 8px;
    padding: 50px;

    .header-wrapper {
        display: flex;
        border-bottom: 1px solid rgba(38, 32, 101, 0.5);
        align-items: flex-start;
        img {
            width: 52px;
            height: 52px;
        }
        .headers {
            margin-left: 20px;
            padding-bottom: 10px;
            h4 {
                font-weight: normal;
                font-size: 14px;
                line-height: 22px;
                color: #758ebf;
                margin: 0;
                margin-bottom: 10px;
            }

            h3 {
                font-weight: 500;
                font-size: 22px;
                line-height: 26px;
                color: white;
                margin-top: 10px;
            }
        }
    }

    .leader-board {
        margin-top: 60px;
        list-style-type: none;
        padding: 0;
        .leader-board-player {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid rgba(38, 32, 101, 0.5);
            padding: 10px 0;
            .left-side {
                display: flex;
                align-items: center;
                img {
                    width: 46px;
                    height: 46px;
                    margin-right: 20px;
                }
            }
            .right-side {
                display: flex;
                align-items: center;
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 12px;
                display: flex;
                align-items: center;
                color: #a4b1cd;
            }
        }
    }
}
</style>
